import { render, staticRenderFns } from "./EmailRouting.vue?vue&type=template&id=3a9f2b8f&scoped=true"
import script from "./EmailRouting.vue?vue&type=script&lang=js"
export * from "./EmailRouting.vue?vue&type=script&lang=js"
import style0 from "./EmailRouting.vue?vue&type=style&index=0&id=3a9f2b8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9f2b8f",
  null
  
)

export default component.exports